export default {
  methods: {
    goToLogin() {
      this.commonHref('/login');
    },
    goToRegister() {
      this.commonHref('/register');
    },
    goToFindPwd(){
      this.commonHref('/findPwd');
    },
    goToHomePage() {
      this.commonHref('/homePage');
    },
    goToResetpwd() {
      this.commonHref('/resetpwd');
    },
    
    goToProductDetail(query) {
      this.commonHref('/productDetail', query);
    },
    goConsole() {
      const routeUrl = JSON.parse(localStorage.getItem('vuex'))
      if (routeUrl.cache.menuData.length === 0) {
        this.$message.destroy();
        this.$message.warning('无任何菜单权限，请添加后重试')
        return
      }
      this.$router.push(routeUrl.cache.tabData.activeKey)
    },
    /*
    * @path 跳转路径
    */
    commonHref(path, query = {}) {
      this.$router.push({
        path,
        query,
      })
          .catch(() => {});
    }
  },
};